<template>
  <v-form v-model="valid" ref="valueForm">
    <v-container fluid mt-0 pt-0>
      <v-layout wrap>
        <v-flex xs12 v-for="field in fields" :key="field.id">
          <award-field v-if="field.type === 'award'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :required="field.required" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <date-field v-if="field.type === 'date'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <datetime-field v-if="field.type === 'datetime'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <enum-field v-if="field.type === 'enum'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :enums="field.enums" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <file-field v-if="field.type === 'file'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" :indicator-value="object" :indicator-field="field" />
          <float-field v-if="field.type === 'float'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <integer-field v-if="field.type === 'integer'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <string-field v-if="field.type === 'string'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
          <text-field v-if="field.type === 'text'" :readonly="readonly" :label="field.title[locale]" v-model="object.values[field.id]" :rules="genRulesForField(field)" @sync="sync" :key="field.id" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { IndicatorValue } from '@/api/indicators'

import AwardField from '@/components/fields/Award'
import DateField from '@/components/fields/Date'
import DatetimeField from '@/components/fields/Datetime'
import EnumField from '@/components/fields/Enum'
import FileField from '@/components/fields/File'
import FloatField from '@/components/fields/Float'
import IntegerField from '@/components/fields/Integer'
import StringField from '@/components/fields/String'
import TextField from '@/components/fields/Text'

export default {
  components: {
    AwardField,
    DateField,
    DatetimeField,
    EnumField,
    FileField,
    FloatField,
    IntegerField,
    StringField,
    TextField,
  },
  model: {
    prop: 'model',
    event: 'sync'
  },
  props: {
    model: {
      type: IndicatorValue,
      required: true
    },
    fields: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    valid: false,
    object: new IndicatorValue()
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    rules () {
      return []
    }
  },
  watch: {
    valid () {
      this.$emit('on-validate', this.valid)
    },
    model () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$refs.valueForm.resetValidation()
      this.object = this.model

      const awardField = this.fields.find(field => field.type === 'award')

      this.object.values[awardField.id] = this.object.values[awardField.id] || ''
    },
    genRulesForField (field) {
      let rules = []

      if (field.required) {
        rules.push(v => !!v || 'Обязательно нужно указать значение')
      }

      return rules
    },
    sync () {
      this.$emit('sync', this.object)
    }
  }
}
</script>

